/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import { trainingServices } from '../../../../api/services/trainingServices';
import _ from 'lodash';
import { setEmpTrainingData } from '../../../../infra/aggregates/myProfile/TrainingAggregates/getEmpTrainingSlice';
import {
  baseDateFormatting,
  baseTimeFormatting,
} from '../../../../common/helper';
import { DateField } from '../../../../components';

interface PropsValues {
  setEmptrainingDatas: (data: any) => void;
  refresh: boolean;
}

function DTOEmptraining({ setEmptrainingDatas, refresh }: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();

  const store_training: any = useAppSelector(
    (state) => state.getEmpTrainingSlice.empTrainingData,
  );

  useEffect(() => {
    dispatch(setEmpTrainingData(store_training));
    const trainingDataList: any = _.map(store_training, (data: any) => {
      let status: any = 'Scheduled';
      if (data?.status == 1) {
        status = 'Scheduled';
      } else if (data?.status == 2) {
        status = 'Accepted';
      } else if (data?.status == 3) {
        status = 'Completed';
      } else if (data?.status == 4) {
        status = 'Canceled';
      }

      const rowData: any = {
        id: data?.id,
        trainingtype: data?.training_type ? data?.training_type?.name : '--',
        startdate: data?.start_date ?? '--',
        enddate: data?.end_date ?? '--',
        starttime: data?.start_time ?? '--',
        endtime: data?.end_time ?? '--',
        status: status,
        action: data,
        timezone: {
          timezone: data?.timezone,
          offset: data?.timezoneOffset,
        },
      };
      return rowData;
    });
    setEmptrainingDatas(trainingDataList);
  }, [store_training]);

  async function getTrainingList(companyId: number, user_id: number) {
    const response: any = await trainingServices.getTrainingData(
      companyId,
      user_id,
    );

    if (response.response == 'success') {
      dispatch(setEmpTrainingData(response.data));
      const trainingDataList: any = _.map(response.data, (data: any) => {
        let status: any = 'Scheduled';
        if (data?.status == 1) {
          status = 'Scheduled';
        } else if (data?.status == 2) {
          status = 'Accepted';
        } else if (data?.status == 3) {
          status = 'Completed';
        } else if (data?.status == 4) {
          status = 'Canceled';
        }

        const rowData: any = {
          id: data?.id,
          trainingtype: data?.training_type ? data?.training_type?.name : '--',
          startdate: data?.start_date ? (
            <DateField value={data.start_date} format={baseDateFormatting} />
          ) : (
            '--'
          ),
          enddate: data?.end_date ? (
            <DateField value={data.end_date} format={baseDateFormatting} />
          ) : (
            '--'
          ),
          starttime: data?.start_time ? (
            <DateField value={data.start_time} format={baseTimeFormatting} />
          ) : (
            '--'
          ),
          endtime: data?.end_time ? (
            <DateField value={data.end_time} format={baseTimeFormatting} />
          ) : (
            '--'
          ),
          status: status,
          action: data,
        };
        return rowData;
      });
      setEmptrainingDatas(trainingDataList);
    }
  }

  useEffect(() => {
    if (refresh) {
      if (selector.company_id && selector.user_id) {
        getTrainingList(selector.company_id, selector.user_id);
      }
    } else {
      if (selector.company_id && selector.user_id)
        getTrainingList(selector.company_id, selector.user_id);
    }
  }, [refresh]);
  return <></>;
}

export default DTOEmptraining;
